import { InputGroup, Form } from "react-bootstrap";
import { UserData, UserUpdateProfileProps } from "../models/UserData";

export interface UserProfileProps {
    value: UserData;
    onChange?: (newValue: UserUpdateProfileProps) => void;
}

export const UserProfile = ({ value, onChange }: UserProfileProps): React.ReactElement => {
    return (
        <InputGroup className="mb-3">
            <Form.Control style={{ maxWidth: '3rem' }} maxLength={2} value={value.icon} onChange={({ target }) => onChange?.({ icon: target.value })} />
            <Form.Control type='text' maxLength={28} value={value.name} onChange={({ target }) => onChange?.({ name: target.value })} placeholder="Enter your name..." />
        </InputGroup>
    )
}
